import {FC} from 'react';

interface Props {
  height?: number;
  className?: string;
}

const SkeletonLine: FC<Props> = ({height = 6, className}) => (
  <div className={`animate-pulse ${className ?? 'min-w-40'}`}>
    <div style={{height: height * 4}} className="w-full bg-gray-300 rounded"></div>
  </div>
);

export default SkeletonLine;
